import styled from 'styled-components';

import { Item } from '../../../../components/ActionMenu/ActionMenu.styles';
import { Text } from '../../../../components/Text/Text';
import { ANIM, ART_STYLE, COLORS, SPACE } from '../../../../theme/tokens';
import { Panel } from '../StylesStrip/StyleCardMenu.styles';

/** The pill: the same material as the "Art style" chip beside it, as a button that opens the list. */
export const Pill = styled.button<{ $open: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: ${SPACE[8]};
  max-width: 100%;
  min-width: 0;
  /* 2px less than the chip's block padding: the avatar is taller than its text line, so both pills match. */
  padding: ${SPACE[2]} ${SPACE[8]} ${SPACE[2]} ${SPACE[4]};
  border-radius: 999px;
  border: 1px solid ${({ $open }) => ($open ? COLORS.ctaSolid : COLORS.hairline)};
  background: ${COLORS.surfaceCard};
  color: ${COLORS.textMuted};
  font-family: inherit;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.2;
  cursor: pointer;
  transition: border-color ${ANIM.INTERACT_MS}ms ${ANIM.EASE};

  &:hover:not(:disabled),
  &:focus-visible {
    border-color: ${COLORS.hoverBorder};
  }

  &:disabled {
    cursor: default;
    opacity: 0.5;
  }

  svg {
    flex: none;
  }
`;

export const PillLabel = styled.span`
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const PillName = styled(Text)`
  color: ${COLORS.textBright};
`;

/** "Auto": up to three avatars overlapping, each ringed in the pill's surface so the overlap reads. */
export const Stack = styled.span`
  display: inline-flex;
  flex: none;
  align-items: center;

  > * {
    box-shadow: 0 0 0 1.5px ${COLORS.surfaceCard};
  }

  > * + * {
    /* Overlap by about a third of the small avatar. */
    margin-left: -${SPACE[8]};
  }
`;

/** The list: the styles strip's card-menu material, raised above the sheets and the storyboard canvas it can
 *  open from (the canvas' own selects sit on this layer too). */
export const MenuPanel = styled(Panel)`
  z-index: 2147483001;
  min-width: ${ART_STYLE.MASCOT_MENU_WIDTH_PX}px;
  max-height: min(60vh, 420px);
  overflow-y: auto;
`;

export const Option = styled(Item)`
  gap: ${SPACE[12]};
`;

export const OptionCopy = styled.span`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: ${SPACE[2]};
  min-width: 0;
`;

export const OptionLabel = styled(Text)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  color: inherit;
`;

export const OptionHint = styled(Text)`
  font-size: 12px;
  color: ${COLORS.textFaint};
`;

export const Check = styled.span<{ $on: boolean }>`
  display: inline-flex;
  flex: none;
  color: ${COLORS.ctaSolid};
  visibility: ${({ $on }) => ($on ? 'visible' : 'hidden')};
`;
